import script from "./LingoWordUploadMetaView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LingoWordUploadMetaView.vue?vue&type=script&setup=true&lang=ts"

import "./LingoWordUploadMetaView.vue?vue&type=style&index=0&id=92cc77c0&scoped=true&lang=css"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92cc77c0"]])

export default __exports__